import React from 'react';
import { isSimConversionRequested, isSimConvertedYes } from '../../../shared/portActivation';

/**
 * Port Form Component for Add/Edit
 */
export default function PortForm({
  formData,
  editingPort,
  gateways,
  handleInputChange,
  handleSubmit,
  resetForm,
}) {
  return (
    <div className="card mb-4">
      <div className="card-body">
        <form onSubmit={handleSubmit}>
          <div className="row g-3">
            <div className="col-md-4 col-lg-3 col-xl-2">
              <label className="form-label">Number source</label>
              <select
                className="form-select form-select-sm"
                name="number_source"
                value={formData.number_source || 'gateway'}
                onChange={handleInputChange}
                disabled={!!editingPort}
                title={
                  editingPort
                    ? 'Source cannot be changed on edit. Convert a gateway SIM with SIM Converted.'
                    : undefined
                }
              >
                <option value="gateway">Gateway</option>
                <option value="service">Service</option>
              </select>
            </div>

            {formData.number_source !== 'service' && (
              <>
            {/* Gateway */}
            <div className="col-md-4 col-lg-3 col-xl-2">
              <label className="form-label">Gateway</label>
              <select
                className="form-select form-select-sm"
                name="gateway_id"
                value={formData.gateway_id}
                onChange={handleInputChange}
                required={formData.number_source !== 'service'}
              >
                {gateways.length === 0 && (
                  <option value="">(no gateways)</option>
                )}
                {gateways.map((gw) => (
                  <option key={gw.id} value={gw.id}>
                    {gw.name || `gw-${gw.id}`}
                  </option>
                ))}
              </select>
            </div>

            {/* Port Number */}
            <div className="col-md-4 col-lg-3 col-xl-2">
              <label className="form-label">Port Number</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="port_number"
                value={formData.port_number}
                onChange={handleInputChange}
                required={formData.number_source !== 'service'}
              />
            </div>
              </>
            )}

            {/* Assigned Number */}
            <div className="col-md-4 col-lg-3 col-xl-2">
              <label className="form-label">Assigned Number</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="assigned_number"
                value={formData.assigned_number}
                onChange={handleInputChange}
                required
              />
            </div>

            {/* User Code */}
            <div className="col-md-4 col-lg-3 col-xl-2">
              <label className="form-label">User Code</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="user_code"
                value={formData.user_code}
                onChange={handleInputChange}
              />
            </div>

            {/* User Email */}
            <div className="col-md-4 col-lg-3 col-xl-2">
              <label className="form-label">User Email</label>
              <input
                type="email"
                className="form-control form-control-sm"
                name="user_email"
                value={formData.user_email}
                onChange={handleInputChange}
              />
            </div>

            {/* Slack User ID */}
            <div className="col-md-4 col-lg-3 col-xl-2">
              <label className="form-label">Slack User ID</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="slack_user_id"
                value={formData.slack_user_id}
                onChange={handleInputChange}
              />
              <small className="text-muted">
                Auto-filled based on User Code
              </small>
            </div>

            {/* Credit Balance */}
            <div className="col-md-4 col-lg-3 col-xl-2">
              <label className="form-label">Credit Balance (£)</label>
              <input
                type="number"
                step="0.01"
                className="form-control form-control-sm"
                name="credit_balance"
                value={formData.credit_balance}
                onChange={handleInputChange}
              />
            </div>

            {/* Last Message Sent */}
            <div className="col-md-4 col-lg-3 col-xl-2">
              <label className="form-label">Last Message Sent</label>
              <input
                type="date"
                className="form-control form-control-sm"
                name="last_message_sent"
                value={formData.last_message_sent}
                onChange={handleInputChange}
              />
            </div>

            {/* Description */}
            <div className="col-md-8 col-lg-6 col-xl-4">
              <label className="form-label">Description</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
              />
            </div>

            {editingPort && formData.number_source !== 'service' && formData.gateway_id && (
              <>
                {/* SIM Converted */}
                <div className="col-md-4 col-lg-3 col-xl-2">
                  <label className="form-label">SIM Converted</label>
                  <select
                    className="form-select form-select-sm"
                    name="is_sim_converted"
                    value={formData.is_sim_converted || '1'}
                    onChange={handleInputChange}
                  >
                    <option value="1">No</option>
                    <option value="2">Yes</option>
                  </select>
                  {isSimConversionRequested(editingPort) && !isSimConvertedYes(editingPort) && (
                    <div className="form-text">
                      <span
                        className="badge"
                        style={{ backgroundColor: '#fd7e14', color: '#fff' }}
                      >
                        Conversion requested
                        {editingPort.req_sim_conversion_id
                          ? ` #${editingPort.req_sim_conversion_id}`
                          : ''}
                        {editingPort.req_sim_conversion_source === 'bulk' ? ' (bulk)' : ''}
                      </span>
                    </div>
                  )}
                </div>

                {/* Sim Converted Note */}
                <div className="col-md-8 col-lg-6 col-xl-4">
                  <label className="form-label">Sim Converted Note</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="sim_converted_note"
                    value={formData.sim_converted_note || ''}
                    onChange={handleInputChange}
                  />
                </div>
              </>
            )}
          </div>

          <div className="mt-3">
            <button
              type="submit"
              className="btn btn-primary btn-sm me-2"
            >
              {editingPort ? 'Update Port' : 'Add Port'}
            </button>
            {editingPort && (
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={resetForm}
              >
                Cancel Edit
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}


